export class GifPlayer {
	/**
	 * Initialize GIF and video play/pause controls
	 */
	constructor() {
		this.buttons = document.querySelectorAll(".pause-button");
		this.isReducedMotion = window.matchMedia(
			"(prefers-reduced-motion: reduce)"
		).matches;

		this.init();
	}

	/**
	 * 🎬 Initialize all media players
	 * @private
	 * @returns {void}
	 */
	init() {
		this.buttons.forEach((button) => this.setupButton(button));

		// If user prefers reduced motion, pause all media by default
		if (this.isReducedMotion) {
			this.buttons.forEach((button) => this.pause(button));
		}
	}

	/**
	 * 🔘 Set up click handler for a pause button
	 * @private
	 * @param {HTMLButtonElement} button
	 * @returns {void}
	 */
	setupButton(button) {
		const figure = button.closest(".image-wrap--gif, .image-wrap--video");
		if (!figure) return;

		const isVideo = figure.classList.contains("image-wrap--video");
		const media = isVideo
			? figure.querySelector(".image-wrap__video")
			: figure.querySelector(".image-wrap__image");

		if (!media) return;

		// Store original src for GIF play/pause
		if (!isVideo) {
			button.dataset.src = media.src;
		}

		button.addEventListener("click", () => this.toggle(button));

		// Make entire video area clickable
		if (isVideo) {
			figure.addEventListener("click", (e) => {
				if (e.target.closest(".pause-button")) return;
				this.toggle(button);
			});
		}
	}

	/**
	 * 🔄 Toggle play/pause state
	 * @private
	 * @param {HTMLButtonElement} button
	 * @returns {void}
	 */
	toggle(button) {
		const isPaused = button.getAttribute("aria-pressed") === "true";

		if (isPaused) {
			this.play(button);
		} else {
			this.pause(button);
		}
	}

	/**
	 * ▶️ Play media
	 * @private
	 * @param {HTMLButtonElement} button
	 * @returns {void}
	 */
	play(button) {
		const figure = button.closest(".image-wrap--gif, .image-wrap--video");
		if (!figure) return;

		const isVideo = figure.classList.contains("image-wrap--video");

		if (isVideo) {
			const video = figure.querySelector(".image-wrap__video");
			if (video) video.play();
		} else {
			const img = figure.querySelector(".image-wrap__image");
			if (!img) return;

			// Reload GIF to restart animation
			const src = button.dataset.src;
			img.src = "";
			img.src = src;
		}

		button.setAttribute("aria-pressed", "false");
	}

	/**
	 * ⏸️ Pause media
	 * @private
	 * @param {HTMLButtonElement} button
	 * @returns {void}
	 */
	pause(button) {
		const figure = button.closest(".image-wrap--gif, .image-wrap--video");
		if (!figure) return;

		const isVideo = figure.classList.contains("image-wrap--video");

		if (isVideo) {
			const video = figure.querySelector(".image-wrap__video");
			if (video) video.pause();
		} else {
			const img = figure.querySelector(".image-wrap__image");
			if (!img) return;

			// Create canvas to capture current frame
			const canvas = document.createElement("canvas");
			canvas.width = img.naturalWidth;
			canvas.height = img.naturalHeight;

			const ctx = canvas.getContext("2d");
			ctx.drawImage(img, 0, 0);

			// Replace img src with static frame
			img.src = canvas.toDataURL();
		}

		button.setAttribute("aria-pressed", "true");
	}
}
